export function getDDayString(dDayCount: number) {
  if (dDayCount > 0) {
    return `D+${dDayCount}`;
  }
  if (dDayCount < 0) {
    return `D${dDayCount}`;
  }
  if (dDayCount === 0) {
    return 'D-Day';
  }
  throw new Error();
}
